//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CobranzaApi from '@/api/promotores/cobranzas.api'

export default {
  data() {
    return {
      loading: false,
      cobranza: {
        nombre: null,
        direccion: null,
        usuario_id: null,
        telefono: null,
        email: null,
        adeudo: null,
        recompensa: null,
        mapa: null,
      }
    };
  },

  methods: {
    show() {
      this.$refs.dialog.show();
    },

    hide() {
      this.$refs.dialog.hide();
    },

    async submit() {
      this.loading = true
      const cobranza = await CobranzaApi.create(this.cobranza)
      this.$emit('ok', cobranza)
      this.loading = false
      this.hide()
    },
  },
};
